import posthog from 'posthog-js'

/**
 * Fire a PostHog product event (the named funnel events for PDR 011 §14).
 *
 * Uses the global posthog-js singleton — the same instance PostHogProvider
 * initializes in main.tsx — so it captures to the configured (cookieless) project.
 * No-op outside production (analytics is prod-only; the provider isn't mounted in
 * dev/native), and it never throws: analytics must never break the UX.
 */
export function track(event: string, properties?: Record<string, unknown>): void {
  if (!import.meta.env.PROD) return
  try {
    posthog.capture(event, properties)
  } catch {
    /* swallow — a failed analytics call must not surface to users */
  }
}
